"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var LocaleWrapper_1 = require("../../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../../locale/en_US"));
var _get = require('lodash/get');
var _isEqual = require('lodash/isEqual');
var Option = antd_1.Select.Option;
/** GraphicTypeField to select between different GraphicTypes */
var GraphicTypeField = /** @class */ (function (_super) {
    __extends(GraphicTypeField, _super);
    function GraphicTypeField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Iterates over props.graphicTypes and returns an Option according to GraphicType
         *
         * @param {GraphicTypeFieldLocale} locale Language package used for the displayed text of an Option
         * @return {React.ReactNode[]} List of Options
         */
        _this.getTypeSelectOptions = function (locale) {
            return (_this.props.graphicTypes.map(function (type) {
                var loc = _get(locale, type) || type;
                return (React.createElement(Option, { key: type, value: type }, loc));
            }));
        };
        return _this;
    }
    GraphicTypeField.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    GraphicTypeField.prototype.render = function () {
        var _a = this.props, locale = _a.locale, graphicType = _a.graphicType, graphicTypes = _a.graphicTypes, onChange = _a.onChange, clearable = _a.clearable, passThroughProps = __rest(_a, ["locale", "graphicType", "graphicTypes", "onChange", "clearable"]);
        return (React.createElement(antd_1.Select, __assign({ className: "editor-field graphictype-field", value: graphicType, onChange: onChange, allowClear: clearable }, passThroughProps), this.getTypeSelectOptions(locale)));
    };
    GraphicTypeField.componentName = 'GraphicTypeField';
    GraphicTypeField.defaultProps = {
        locale: en_US_1.default.GsGraphicTypeField,
        graphicTypes: ['Mark', 'Icon'],
        clearable: true
    };
    return GraphicTypeField;
}(React.Component));
exports.GraphicTypeField = GraphicTypeField;
exports.default = LocaleWrapper_1.localize(GraphicTypeField, GraphicTypeField.componentName);
//# sourceMappingURL=GraphicTypeField.js.map